module.exports = __webpack_public_path__ + "static/media/bg_login.4732e630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_login.jpg
// module id = 317
// module chunks = 0